export { SchoolEntity } from './school-entity';
export { SchoolEntityList } from './school-entity-list';
export { SchoolProfileEntity } from './school-profile-entity';
export { SchoolProfileGroupEntity } from './school-profile-group.entity';
export { SchoolSummaryStatsEntity } from './school-summary-stats-entity';
export { SchoolRequisitesEntity } from './school-requisites-entity';

export type { Entity as SchoolEntityType } from './school-entity';
